import React from "react";
import "./NavbarOnboarding.modules.css";
import * as Constants from "../../../constants/Constants";

import ADCBLogo from "../../../assets/images/ADCB/Onboarding/newLogo2.png";
import SharjahLogo from "../../../assets/images/Sharjah/newLogo2.png";
import DefaultLogo from "../../../assets/images/Sharjah/newLogo2.png";

const logos = {
  ADCB: ADCBLogo,
  SHARJAH: SharjahLogo,
};

const NavbarOnboarding = () => {
  const clientName = localStorage.getItem(Constants.localStorageConstants.company_name)?.toUpperCase();
  const logoSrc = logos[clientName] || DefaultLogo;

  return (
    <nav className="NavbarOnboarding">
      <div className="NavbarOnboarding-container">
        <img
          src={logoSrc}
          alt="Logo"
          style={{ height: "100%", borderRadius: "10px" }}
        />
      </div>
    </nav>
  );
};

export default NavbarOnboarding;
